export default class PermissionFilterKind {
	static ANONYMOUS = 'ANONYMOUS';
	static AUTHORIZED = 'AUTHORIZED';
	static IN_ANY_OF_ROLES = 'IN_ANY_OF_ROLES';
	static CUSTOM = 'CUSTOM';
	static EVERYONE = 'EVERYONE';
	static NOBODY = 'NOBODY';
}
